import { CallSetProfile, CallSetProfileValidationRule } from 'dialer'
import { MapConfigBaseLayer } from '../app/core/models/mapping'

export type AppConfigDialerSection = {
  graphQLUrl: string
  graphQLWsUrl: string
  earlyDisconnectToleranceSecs?: number
  earlyDisconnectCarrierRegex?: string
  defaultProfile: Partial<CallSetProfile>
  profileValidationRules?: CallSetProfileValidationRule[];
  allowUserProfileEdits?: boolean;
}

type TaskSection = {
  enabled: boolean;
}

export type AppConfigScoutSection = TaskSection;
export type AppConfigPathTestSection = TaskSection &{
  participants?: { name: string, title: string }[]
};
export type AppConfigDriveTestSection = AppConfigPathTestSection;
export type AppConfigMobileTestSection = TaskSection;

export class AppConfigBase {

  production = true
  pwa = false
  rxdbUniquePrefix?: string
  syncUrl!: string
  apiUrl!: string
  wsUrl!: string
  graphQLUrl!: string
  graphQLWsUrl!: string
  wsReconnectDelaySecs = 5
  wsPingIntervalSecs = 5

  dialer: AppConfigDialerSection = {
    graphQLUrl: 'http://127.0.0.1:8001/',
    graphQLWsUrl: 'ws://127.0.0.1:8001/graphql',
    defaultProfile: {
      callCount: 2,
      callDurationSecs: 45,
      callWaitSecs: 30,
      callSetupTimeoutSecs: 15,
    },
    profileValidationRules: [
      {
        fieldName: 'callCount',
        compareMode: 'min',
        compareValue: 1,
        enforce: true,
        description: 'Required minimum call count',
      },
      {
        fieldName: 'callDurationSecs',
        compareMode: 'equal',
        compareValue: 45,
        enforce: false,
        stageRegexFilter: '^(2|3)[a-z]$',
        buildingRegexFilter: '.*',
        description: 'Preferred duration for stages 2 and 3',
      },
      {
        fieldName: 'callWaitSecs',
        compareMode: 'equal',
        compareValue: 30,
        enforce: false,
        description: 'Preferred wait (any test stage)',
      },
      {
        fieldName: 'callSetupTimeoutSecs',
        compareMode: 'equal',
        compareValue: 15,
        enforce: false,
        description: 'Preferred setup timeout (any test stage)',
      }
    ],
    allowUserProfileEdits: true
  }

  fileImport = {
    // import type is enabled if carrierIdRegex OR titleRegex matches
    carrierIdRegex: '^(att|dish|ggl|tmo|vzw|rypplzz)$',
    titleRegex: '(?i)^(baro log|gps log|handsets|lma call log|volunteers|one source.*)$'
  }

  mapConfig = {
    baseLayers: [
      MapConfigBaseLayer.OpenStreetLayer,
      MapConfigBaseLayer.OsmbgLayer
    ]
  }

  rxdb: { collections: { [name: string]: { intervalMs: number } } } = {
    collections: {}
  }

  scout: AppConfigScoutSection = {
    enabled: true
  }
  pathTest: AppConfigPathTestSection = {
    enabled: true
  }
  driveTest: AppConfigDriveTestSection = {
    enabled: false
  }
  mobileTest: AppConfigMobileTestSection = {
    enabled: false
  }

  constructor(public environment: string) {

  }
}
